if (!customElements.get('cart-drawer-upsells')) {
  customElements.define(
    'cart-drawer-upsells',
    class CartDrawerUpsells extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        const preselectedProducts = this.querySelectorAll('.po-cart-upsell').length;
        if (preselectedProducts) {
          this.querySelector('.po-cart-upsells__loading')?.remove();
          this.bindControls();
          return;
        }
        this.loadRecommendations('complementary');
      }

      async loadRecommendations(intent) {
        try {
          const url = `${this.dataset.url}?section_id=cart-drawer-upsells&product_id=${this.dataset.productId}&limit=6&intent=${intent}`;
          const response = await fetch(url);
          if (!response.ok) throw new Error('Recommendations unavailable');
          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const results = documentFragment.querySelector('.po-cart-upsells__results');
          const productCount = results ? results.querySelectorAll('.po-cart-upsell').length : 0;

          if (!productCount && intent === 'complementary') {
            return this.loadRecommendations('related');
          }

          if (!results || !productCount) {
            this.remove();
            return;
          }

          this.innerHTML = results.outerHTML;
          this.bindControls();
        } catch (error) {
          this.remove();
        }
      }

      bindControls() {
        this.querySelectorAll('.po-cart-upsell').forEach((card) => {
          const select = card.querySelector('.po-cart-upsell__variant');
          const button = card.querySelector('.po-cart-upsell__add');
          if (select && button) {
            select.addEventListener('change', () => {
              button.dataset.variantId = select.value;
            });
          }
          if (button) button.addEventListener('click', () => this.addProduct(button));
        });
      }

      isCartPageUpsell() {
        return Boolean(this.closest('.po-cart-page-upsells') && document.getElementById('main-cart-items'));
      }

      replaceCartPageSection(sectionHtml, targetSelector, sourceSelector = targetSelector) {
        if (!sectionHtml) return;
        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const target = document.querySelector(targetSelector);
        const source = parsed.querySelector(sourceSelector);
        if (target && source) target.innerHTML = source.innerHTML;
      }

      async addProduct(button) {
        if (button.disabled) return;
        const originalText = button.textContent;
        const isCartPage = this.isCartPageUpsell();
        const cartItemsSectionId = document.getElementById('main-cart-items')?.dataset.id;
        const cartFooterSectionId = document.getElementById('main-cart-footer')?.dataset.id;
        const sections = isCartPage
          ? [cartItemsSectionId, cartFooterSectionId, 'cart-icon-bubble'].filter(Boolean)
          : ['cart-drawer', 'cart-icon-bubble'];
        button.disabled = true;
        button.textContent = 'Adding…';

        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
              sections,
              sections_url: window.location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || 'Could not add product');

          button.textContent = 'Added ✓';
          if (isCartPage && data.sections) {
            this.replaceCartPageSection(
              data.sections[cartItemsSectionId],
              '#main-cart-items .js-contents',
              '#main-cart-items .js-contents'
            );
            this.replaceCartPageSection(
              data.sections[cartFooterSectionId],
              '#main-cart-footer .js-contents',
              '#main-cart-footer .js-contents'
            );
            this.replaceCartPageSection(
              data.sections['cart-icon-bubble'],
              '#cart-icon-bubble .shopify-section',
              '.shopify-section'
            );
            document.getElementById('main-cart-footer')?.classList.remove('is-empty');
            window.setTimeout(() => {
              button.disabled = false;
              button.textContent = originalText;
            }, 1200);
            return;
          }

          const drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections) drawer.renderContents(data);
        } catch (error) {
          button.disabled = false;
          button.textContent = 'Try again';
          window.setTimeout(() => { button.textContent = originalText; }, 1800);
        }
      }
    }
  );
}
